import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import { useEffect } from "react";

export const AGENT_CHAT_AUTO_OPENED_KEY = "ges-cloud-agent-chat-auto-opened";

const getAgentChatAutoOpenedKey = (userId: string) => `${AGENT_CHAT_AUTO_OPENED_KEY}:${userId}`;

export const useAgentChatAutoOpen = (canOpen: boolean, isOpen: boolean, open: () => void) => {
	const pageData = PageDataContextService.value;
	const userId = pageData.user.info?.mail;
	const { enabled, url } = pageData.conf.enterpriseCloud;
	const isCloud = Boolean(enabled && url);

	useEffect(() => {
		if (!isCloud || !canOpen || isOpen || !userId) return;

		const storageKey = getAgentChatAutoOpenedKey(userId);
		try {
			if (window.localStorage.getItem(storageKey)) return;
			window.localStorage.setItem(storageKey, "true");
			open();
		} catch {
			// A browser that refuses storage keeps the existing closed-by-default behavior.
		}
	}, [isCloud, canOpen, isOpen, userId, open]);
};
